import { UseAppFormProps } from "hooks/useAppForm";
import React, { useEffect } from "react";
import { FormValueProps } from ".";
import AppForm from "components/AppForm";
import { AppAlert, AppMessage } from "components";
import { apiBookingCreate } from "apis";
import { useNavigate } from "react-router-dom";

interface Props {
    form: UseAppFormProps<FormValueProps>
}

export const PageInfo: React.FC<Props> = ({ form }) => {
    const navigate = useNavigate();
    return (
        <div className="p-4 bg-white rounded shadow">
            <h2 className="text-lg font-bold mb-4">NHẬP THÔNG TIN LIÊN HỆ</h2>
            <AppForm<FormValueProps>
                form={form}
                onSubmit={() => {
                    AppAlert.confirm({
                        title: "Xác nhận",
                        content: "Bạn chắc chắn đặt hẹn với thông tin trên?",
                        okText: "Xác nhận",
                        cancelText: "Huỷ",
                        onOk: async () => {
                            console.log(form.values);
                            const { method, ...values } = form.values;
                            const res = await apiBookingCreate(values);
                            if (res.status) {
                                AppMessage.success({
                                    title: "Thông báo",
                                    message: "Đặt hẹn thành công"
                                })
                                navigate(`/dat-hen/ket-qua/${res.data?.item.id}.html`, { replace: true });
                            }
                            else {
                                AppMessage.error({
                                    title: "Thông báo",
                                    message: "Đặt hẹn thất bại"
                                })
                            }
                        }
                    })
                }}
                cols={2}
                shadow={false}
            >
                <AppForm.Input
                    label="Họ và tên"
                    required
                    placeholder="Nhập họ và tên..."
                    col={1}
                    value={form.values.fullName}
                    onChange={(fullName) => form.handleChange({ fullName })}
                    error={form.errors.fullName}
                />
                <AppForm.Input
                    label="Số điện thoại"
                    required
                    placeholder="Nhập số điện thoại..."
                    col={1}
                    value={form.values.email}
                    onChange={(email) => form.handleChange({ email })}
                    error={form.errors.email}
                />
                <AppForm.Textarea
                    label="Mô tả tình trạng"
                    placeholder="Mô tả tình trạng"
                    value={form.values.description}
                    onChange={(description) => form.handleChange({ description })}
                    col={2}
                />
                <AppForm.Action>
                    <button
                        type="submit"
                        className={`mt-4 px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700`}
                    >
                        Xác nhận đặt hẹn
                    </button>
                </AppForm.Action>
            </AppForm>
        </div>
    );
};
